
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export function SoftwareCTA() {
  const { ref, isVisible } = useScrollAnimation();
  const whatsappMessage = encodeURIComponent('Hola, me contacto desde el sitio web STI. Me interesa consultar sobre licencias de software legal para mi empresa.');

  return (
    <section className="py-20 bg-gray-950 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,255,240,0.06),transparent_50%)]"></div>
      <div ref={ref} className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 anim-fade-up ${isVisible ? 'visible' : ''}`}>
        <div className="bg-gray-900/80 rounded-2xl border border-gray-800 p-10 sm:p-14 text-center relative overflow-hidden">
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-neon-400/50 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-rosa-400/50 to-transparent"></div>

          <div className="w-16 h-16 flex items-center justify-center bg-neon-400/10 border border-neon-400/20 rounded-2xl mx-auto mb-6">
            <i className="ri-file-shield-2-line text-3xl text-neon-400"></i>
          </div>

          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">
            ¿Necesitás <strong className="text-neon-400">regularizar</strong> tu software?
          </h2>
          <p className="text-sm text-gray-400 mb-8 max-w-xl mx-auto leading-relaxed">
            Contactanos para una auditoría gratuita. Te asesoramos sobre las mejores opciones de licenciamiento para tu empresa con los mejores precios del mercado.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`https://wa.me/5491140402887?text=${whatsappMessage}`}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-green-600 hover:bg-green-500 text-white text-sm font-semibold rounded-lg transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              Consultar por WhatsApp
            </a>
            <a
              href="tel:01140402887"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gray-800 hover:bg-gray-700 text-white text-sm font-semibold rounded-lg border border-gray-700 hover:border-gray-600 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-lg"></i>
              011-4040-2887
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
